import(/* webpackMode: "eager" */ "/home/ubuntu/m.seungfung.com/src/app/page.tsx");
